import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
export class DXFAPIs extends EarthBrainViewerAPIs {
    async addDXFFromJSON(id, json) {
        return await this._scDesign.addDXFFromJSON(id, json);
    }
    setDXFVisibility(id, visible) {
        this._scDesign.setDXFVisibility(id, visible);
    }
    setDXFColor(id, color) {
        this._scDesign.updateDXFColor(id, color);
    }
    zoomToDXF(id) {
        this._scDesign.zoomToDXF(id);
    }
    removeDXF(id) {
        this._scDesign.removeDXF(id);
    }
    async adjustHeightOfDXFData(id, assetType, assetID) {
        await this._scDesign.adjustHeightOfDXFData(id, assetType, assetID);
    }
    async resetHeightOfDXFData(id) {
        await this._scDesign.resetHeightOfDXFData(id);
    }
    getCentralLineDataOfDXF(id) {
        return this._scDesign.getCentralLineDataOfDXF(id);
    }
    getDXFJSON(id) {
        return this._scDesign.getDXFJSON(id);
    }
    exportDXFToSima(id, siteName, filename = "output") {
        this._scDesign.exportDXFToSima(id, siteName, filename);
    }
}
//# sourceMappingURL=dxf-apis.js.map